const translation = {
  // Navbar
  "nav.benefits": "Beneficios",
  "nav.mission": "Nuestra Misión",
  "nav.contact": "Contacto",
  "nav.cta": "Consulta Gratuita",

  // Hero
  "hero.financing": "Financiamiento Automático para Iglesias — 0% Interés",
  "hero.financing.sub": "Sin bancos. Sin complicaciones. Haz crecer tu ministerio sin presión financiera.",
  "hero.financing.nobank": "Sin bancos",
  "hero.financing.approved": "Aprobación rápida",
  "hero.badge": "Soluciones LED Premium para Iglesias",
  "hero.headline1": "Más Que Pantallas.",
  "hero.headline2": "Una Experiencia de Adoración.",
  "hero.sub": "Transforma cómo tu iglesia se comunica, conecta y ministra a través de soluciones LED inmersivas diseñadas para la adoración.",
  "hero.cta1": "Agenda una Consulta Gratuita",
  "hero.cta2": "Cómo Funciona",
  "hero.scroll": "Desplázate para explorar",

  // Benefits
  "benefits.badge": "Por Qué AdoraLED",
  "benefits.title1": "Diseñado para Iglesias.",
  "benefits.title2": "Construido para el Impacto.",
  "benefits.0.title": "Eleva la Atmósfera de Adoración",
  "benefits.0.desc": "Crea ambientes inmersivos que ayudan a las personas a conectarse profundamente con Dios. Transforma cualquier servicio en una experiencia trascendente e inolvidable.",
  "benefits.1.title": "Comunicación Clara y Poderosa",
  "benefits.1.desc": "Haz que cada mensaje, letra y visual sea más impactante y memorable. Tu congregación sentirá cada palabra, no solo la escuchará.",
  "benefits.2.title": "Convierte Visitantes en Miembros",
  "benefits.2.desc": "Las primeras impresiones importan — crea una experiencia a la que la gente quiera volver. Un ambiente visual poderoso construye comunidad duradera.",
  "benefits.3.title": "Solución Todo en Uno",
  "benefits.3.desc": "Nosotros manejamos todo: diseño, instalación y soporte continuo. Desde la primera consulta hasta el último píxel — estamos contigo.",
  "benefits.4.title": "Financiamiento Flexible – Sin Intereses",
  "benefits.4.desc": "Sin bancos. Sin complicaciones. Haz crecer tu iglesia sin presión financiera. Nuestros planes están diseñados para tu ministerio, no para el lucro.",
  "benefits.cta.title": "¿Listo para Transformar tu Iglesia?",
  "benefits.cta.desc": "Únete a cientos de iglesias que han elevado su experiencia de adoración con AdoraLED.",
  "benefits.cta.button": "Comienza Hoy",

  // Gallery
  "gallery.badge": "Nuestras Instalaciones",
  "gallery.title1": "Iglesias Reales.",
  "gallery.title2": "Transformaciones Reales.",
  "gallery.sub": "Mira cómo hemos transformado espacios de adoración en todo el país con soluciones LED premium diseñadas para el impacto.",
  "gallery.cta.text": "¿Quieres ver tu iglesia transformada así?",
  "gallery.cta.button": "Obtén Tu Consulta Gratuita",

  // Emotional
  "emotional.quote1": "\"Porque la adoración nunca fue solo para ser escuchada\u2026",
  "emotional.quote2": "fue creada",
  "emotional.quote3": "para ser experimentada.\"",
  "emotional.sub1": "Esto no se trata de pantallas.",
  "emotional.sub2": "Se trata de crear momentos donde",
  "emotional.highlight": "las vidas son transformadas.",
  "emotional.stat1.value": "500+",
  "emotional.stat1.label": "Iglesias Transformadas",
  "emotional.stat2.value": "10+",
  "emotional.stat2.label": "Años de Excelencia",
  "emotional.stat3.value": "100%",
  "emotional.stat3.label": "Satisfacción del Cliente",

  // Contact
  "contact.badge": "Contáctanos",
  "contact.title1": "Diseñemos la Experiencia",
  "contact.title2": "para Tu Iglesia",
  "contact.intro": "Cuéntanos un poco sobre tu iglesia y te mostraremos lo que es posible. Sin presión, solo una conversación genuina sobre tu visión.",
  "contact.trust1": "Sin obligación. Solo una conversación.",
  "contact.trust2": "Respuesta en menos de 24 horas.",
  "contact.trust3": "Especialista dedicado para tu iglesia.",
  "contact.label.name": "Nombre Completo",
  "contact.label.church": "Nombre de la Iglesia",
  "contact.label.email": "Correo Electrónico",
  "contact.label.phone": "Teléfono / WhatsApp",
  "contact.label.city": "Ciudad y Estado",
  "contact.label.screen_area": "Área de la Pantalla (pulgadas o pies)",
  "contact.label.message": "Mensaje (opcional)",
  "contact.placeholder.name": "Pastor Juan García",
  "contact.placeholder.church": "Iglesia Gracia Comunidad",
  "contact.placeholder.email": "pastor@iglesia.com",
  "contact.placeholder.phone": "+1 (555) 000-0000",
  "contact.placeholder.city": "Miami, FL",
  "contact.placeholder.screen_area": "Ej. 3m x 2m o 120pulg x 72pulg",
  "contact.placeholder.message": "Cuéntanos sobre tu visión, tamaño de la congregación o cualquier pregunta\u2026",
  "contact.submit": "Solicitar Mi Consulta Gratuita",
  "contact.sending": "Enviando\u2026",
  "contact.trust_note": "Sin obligación. Solo una conversación para explorar tu visión.",
  "contact.error": "Algo salió mal. Por favor intenta de nuevo.",
  "contact.success.title": "\u00a1Recibimos tu solicitud!",
  "contact.success.desc": "Nuestro equipo se comunicará contigo en menos de 24 horas para agendar tu consulta gratuita.",
  "contact.success.another": "Enviar otra solicitud",

  // Footer
  "footer.tagline": "Más Que Pantallas. Una Experiencia de Adoración.",
  "footer.copyright": "\u00a9 {year} AdoraLED. Todos los derechos reservados. Soluciones LED Premium para Iglesias."
};

export default translation;
